// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/elementos_documentos_pdf/get/{name}
 * and GET /config/elementos_documentos_pdf/getByName/{name}.
 *
 * Returns a single PDF page-element record by name from the external
 * html2pdf micro-service via chama_servico(). The single record has the
 * same shape as one row of the list endpoint, so it is typed by the same
 * sibling ElementosDocumentosPdf_ListRow contract.
 */
import type { ElementosDocumentosPdf_ListRow } from './ElementosDocumentosPdf_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ElementosDocumentosPdf_GetResponseDados = ElementosDocumentosPdf_ListRow;

export type ElementosDocumentosPdf_GetResponse = ApiResponse<ElementosDocumentosPdf_GetResponseDados>;

registerResponseContract('ElementosDocumentosPdf_GetResponse', {
  _nullable: { type: 'boolean', required: false },
  ID:        { type: 'number',  required: false },
  CreatedAt: { type: 'string',  required: false },
  UpdatedAt: { type: 'string',  required: false },
  DeletedAt: { type: 'string',  required: false },
  type:      { type: 'string',  required: false },
  name:      { type: 'string',  required: false },
  data:      { type: 'string',  required: false },
})
